import { render, staticRenderFns } from "./CountryInfoSlider.vue?vue&type=template&id=e53c49e8&"
import script from "./CountryInfoSlider.vue?vue&type=script&lang=js&"
export * from "./CountryInfoSlider.vue?vue&type=script&lang=js&"
import style0 from "./CountryInfoSlider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports